<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 标签选择
  -->
  <div class="tag-select" v-if="visible" :style="{ top: top }">
    <div class="header">
      <div class="item">姓名</div>
      <div class="item">职位</div>
      <div class="item">个人主页(用户ID)</div>
    </div>
    <div class="people-list">
      <div class="poeple-item" v-for="(item, i) in list2" :key="i">
        <el-input v-model="list2[i].name" />
        <el-input v-model="list2[i].position" />
        <el-input v-model="list2[i].accountId" />
        <el-button type="info" size="mini" @click="list2.splice(i, 1)">
          删除
        </el-button>
      </div>
    </div>
    <div class="tag" v-if="!isInput" @click="inputClick">+ 添加</div>
    <div class="footer">
      <el-button type="primary" style="width: 200px" @click="confirm">
        确定
      </el-button>
      <el-button type="warning" @click="$emit('visibleChange', false)">
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    creatorList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    creatorList(new_value, old_value) {
      if (new_value != old_value) {
        this.list2 = this.creatorList;
      }
    },
    tagsList(new_value, old_value) {
      console.log(new_value);
      if (new_value != old_value) {
        this.tagsListTemp = this.new_value;
      }
    },
  },
  data() {
    return {
      top: "30px",
      list: [],
      isInput: false,
      value: "",
      tagsListTemp: [],
      list2: [],
    };
  },
  created() {
    this.tagsListTemp = this.tagsList;
  },
  methods: {
    confirm() {
      let ifNull = false;
      this.list2.map((el) => {
        if (
          el.name == undefined ||
          el.name == "" ||
          el.position == undefined ||
          el.position == ""
        ) {
          ifNull = true;
        }
      });
      if (ifNull) {
        this.$message.error("不能有空值");
        return;
      }
      this.$emit("change", this.list2);
      this.$emit("visibleChange", false);
    },
    click(item) {
      if (this.list.includes(item)) {
        this.list = this.list.map((el) => {
          if (el != item) {
            return el;
          }
        });
      } else {
        this.list.push(item);
      }
    },
    inputClick() {
      this.list2.push({ name: "", position: "", accountId: "" });
      setTimeout(() => {
        // this.$refs.tagInput.focus();
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.tag-select {
  position: absolute;
  width: 484px;
  // height: 340px;
  padding: 6px;
  border-radius: 4px;
  box-shadow: 0 10px 40px 10px rgba(51, 51, 51, 0.4);
  background: #ffffff;
  z-index: 100;
  .title {
    display: inline-block;
    width: 100%;
    font-size: 12px;
    font-weight: 700;
    color: #666666;
    padding-left: 3px;
    margin-bottom: 12px;
  }
  .content {
    font-size: 12px;
    color: #999;
    display: inline;
  }
  .tag {
    display: inline-block;
    width: 100%;
    margin-right: 0.5%;
    margin-bottom: 6px;
    border-radius: 4px;
    font-size: 12px;
    border: solid 1px #dcdcdc;
    color: #333333;
    text-align: center;
    user-select: none;
    cursor: pointer;
    transition: all 0.2s;
  }
  .tag-input {
    width: 100%;
    margin-right: 0.5%;
  }
  .checked {
    border: 1px solid #ff5b67;
    transition: all 0.2s;
  }
  .footer {
    position: relative;
    left: 25%;
    // top: 100px;
  }
}
.header {
  display: flex;
  .item {
    width: 29.3%;
  }
}
.people-list {
  .poeple-item {
    margin: 10px 0;
    .el-input {
      width: 26.3%;
      margin-right: 3%;
    }
  }
}
</style>
